import axios from 'axios';

export default axios.create({
    baseURL: '/api/v1/',
    method: 'GET',
    headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
    },
    withCredentials: true,
    transformResponse: [
        function (data) {
            console.log('RAW AXIOS RESPONSE:', data);

            if (!data) return data;

            try {
                return JSON.parse(data);
            } catch (e) {
                console.warn('NOT JSON, RETURNING TEXT:', data);
                return data; 
            }
        }
    ]
});
